import axios from 'axios';
import domainByEnv from './domainByEnv';

interface I_HandleFavorite {
    isLogin: boolean;
    isFavorite: boolean;
    TravelType: string | number;
    Price: string | number;
    TourDays: number;
    NormGroup: string;
    GroupID: string;
    NormGroupID: string;
    GoDate: string;
    setIsFavorite: (isFav: boolean) => void;
    setFavList?: Function;
    favList?: [{ ProductID: string }];
}

interface I_FavData {
    ProductList: I_FavItem[];
}

interface I_FavItem {
    TravelType: string; // 旅遊型態
    ProductID: string; // GroupID
    NormGroupID: string; // 標準團名
    Price: number; // 價格
    Days: number; // 天數
}

export const handleFavorite = async ({
    isLogin,
    isFavorite,
    TravelType,
    Price,
    TourDays,
    NormGroup,
    NormGroupID,
    GroupID,
    GoDate,
    setIsFavorite,
    setFavList,
    favList,
}: I_HandleFavorite) => {
    if (isLogin) {
        try {
            // 若已收藏，刪除收藏；若未收藏，加入收藏
            // const payload = isFavorite ? deletePayload : insertPayload;
            const api = isFavorite ? 'deletefavorite' : 'insertfavorite';

            const insertQueryString = `{"traveltype":${TravelType},"price":${
                Price ? Number(Price.toString().replace(',', '')) : 0
            },"days":${TourDays},"productname":"${NormGroup}","departuredate":"${GoDate}","productid":"${GroupID}","normgroupid":"${NormGroupID}","name":"Favorite"}`;
            const deleteQueryString = `{"traveltype":${TravelType},"productid":"${GroupID}","name":"Favorite"}`;
            const queryString = isFavorite ? deleteQueryString : insertQueryString;

            const res = await fetch(
                `${domainByEnv()}/common/common/${api}?jsonStr=${encodeURIComponent(queryString)}`,
                {
                    method: 'POST',
                }
            );

            await res.json();
            setIsFavorite(isFavorite ? false : true);
            // 處理 favList 新增 & 刪除
            const isFavInMemory =
                favList?.find((favItem: any) => favItem.ProductID === GroupID) || false;

            if (!isFavorite && !isFavInMemory && setFavList) {
                // 添加 { ProductID: groupId } 至favList中
                setFavList((preState: any) =>
                    Array.isArray(preState)
                        ? [...preState, { ProductID: GroupID }]
                        : [{ ProductID: GroupID }]
                );
            } else if (isFavorite && isFavInMemory && setFavList) {
                // 從favList中刪除{ProductID: groupId}
                const filterFavList = favList?.filter((favItem) => favItem?.ProductID !== GroupID);
                setFavList(filterFavList);
            }
        } catch (err) {
            console.log('error =>', err);
        }
    } else {
        sessionStorage.setItem('waitedForAddedFav', GroupID);
        // 開啟登入光箱
        window.Templates.login_lion.default.OpenLogin();
    }
};

// 0 : 搜尋結果頁用，for 團體 + 團體自由行
// 1 : 產品頁用，for 團體
// 2 : 產品頁用，for 團體自由行
export const getIsFavorite = async (TravelType: string | number) => {
    const { data }: { data: I_FavData } = await axios.get(
        `${domainByEnv()}/common/common/getfavoritebytype?type=${TravelType}`
    );

    return data.ProductList;
};
